import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'date_of_birth',
    title: 'Date of birth',
    is_required: true,
    question_type: 'date',
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Filing status',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single, or married but legally separated',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
      {
        codeValue: 'married_withhold_higher_rate',
        shortName: 'Married, but withhold at higher single rate',
      },
    ],
  },
  {
    id: 'date_of_hire',
    title: 'Date of hire',
    is_required: true,
    question_type: 'date',
  },
];

export const initialAllowancesQuestions = [
  {
    id: 'dependents',
    title: 'Enter the number of exemptions for dependents. You are entitled to claim an exemption for each dependent. (Line 1)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_amount',
    title: 'Enter an additional amount per pay period you want deducted (if your employer agrees). (Line 2)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
